module.exports = __webpack_public_path__ + "static/media/Avenir-Light.69c0fd9e.woff";